import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getSdkVersion } from '@wix/wix-data-client-common/dist/esm/infra/getSdkVersion'

function createCMSWebPanelUrlGetter(baseUrl: string) {
  return async ({
    hostname,
    editorSdkProxy,
  }: {
    hostname: string
    editorSdkProxy: EditorSDK
  }) => {
    const sdkVersion = await getSdkVersion(editorSdkProxy)
    const query = new URLSearchParams({ sdkVersion }).toString()
    return `//${hostname}/${baseUrl}?${query}`
  }
}

const CMS_WEB_CREATE_COLLECTION_PANEL_URL =
  '_api/cms-web-create-collection-panel/editor-panel-app'

const CMS_WEB_CREATE_COLLECTION_PANEL_V2_URL =
  '_api/cms-web-create-collection-panel/editor-panel-app-v2'

const CMS_WEB_EDIT_COLLECTION_PANEL_V2_URL =
  '_api/cms-web-edit-collection-panel/edit-collection/editor-panel-app-v2'

const CMS_WEB_VIEW_PERMISSIONS_PANEL_V2_URL =
  '_api/cms-web-edit-collection-panel/view-permissions/editor-panel-app-v2'

const CMS_WEB_DUPLICATE_COLLECTION_PANEL_URL =
  '_api/cms-web-duplicate-collection-panel/editor-panel-app'

const CMS_WEB_REMOVE_COLLECTION_PANEL_URL =
  '_api/cms-web-remove-collection-panel/editor-panel-app'

export const [
  getCMSWebCreateCollectionPanelUrl,
  getCMSWebCreateCollectionPanelV2Url,
  getCMSWebEditCollectionPanelV2Url,
  getCMSWebViewPermissionsPanelV2Url,
  getCMSWebDuplicateCollectionPanelUrl,
  getCMSWebRemoveCollectionPanelUrl,
] = [
  CMS_WEB_CREATE_COLLECTION_PANEL_URL,
  CMS_WEB_CREATE_COLLECTION_PANEL_V2_URL,
  CMS_WEB_EDIT_COLLECTION_PANEL_V2_URL,
  CMS_WEB_VIEW_PERMISSIONS_PANEL_V2_URL,
  CMS_WEB_DUPLICATE_COLLECTION_PANEL_URL,
  CMS_WEB_REMOVE_COLLECTION_PANEL_URL,
].map(createCMSWebPanelUrlGetter)
